// The NAME LINES a plain chat puts over each story field the user takes from
// Loom's proposal, and the ONE place they are spelled.
//
// Focus Chat shows the `draft` of each open role / means / ends slot with a
// button that sends it back as the user's own message. A chat message carries no
// attribution — no `question_answer` frame, no `cardAnswers` — so when several
// answers go out in one message, nothing but the text itself says which field
// each one is for. So each story answer goes out under a line of its own naming
// it:
//
//   Role:
//   Projektverantwortliche
//
//   So that:
//   ich auf einen Blick sehe …
//
// and the chat directive tells the model that the value is ONLY the text below
// that line. The client (`composeChatBatch`) and the server prompt
// (`pm-mode-directive.ts`, `CHAT_DRAFT`) both read these, so the label a message
// carries and the label the model is told about cannot drift apart.
//
// GROUNDING PLANE — English by contract, like "Priority: High": the words are
// part of the user's turn and the prompt names them. Localizing them would need
// the prompt to carry every language's labels.
//
// Not the spec's own labels ("User", "Capability", "Outcome"): the chat's
// message arrives under "User message:", and a first line reading "User:" reads
// like a speaker tag. "I want" and "So that" are the story sentence's own words,
// which is what each clause completes.

export const STORY_ANSWER_LABELS = {
  role: "Role",
  means: "I want",
  ends: "So that",
} as const;

export type StoryAnswerField = keyof typeof STORY_ANSWER_LABELS;

export const isStoryAnswerField = (field: string): field is StoryAnswerField =>
  Object.prototype.hasOwnProperty.call(STORY_ANSWER_LABELS, field);

/** The line a story answer goes out under, e.g. `"So that:"`. */
export const storyAnswerNameLine = (field: StoryAnswerField): string =>
  `${STORY_ANSWER_LABELS[field]}:`;
